import api from "../../../services/api";

const BASE_URL = "project-module/routes";

export const routeService = {
  create: async (data: any) => {
    try {
      const response = await api.post(
        `${BASE_URL}/create-by-project/${data.projectId}`,
        data
      );
      if (response.data?.isSuccess) {
        return response.data.message;
      } else {
        throw new Error(response.data?.message);
      }
    } catch (error) {
      throw error;
    }
  },
  addNewScheduleAndAllocate: async (data: any) => {
    try {
      const response = await api.post(
        `${BASE_URL}/add-new-schedule/${data.projectId}`,
        data
      );
      if (response.data?.isSuccess) {
        return response.data.message;
      } else {
        throw new Error(response.data?.message);
      }
    } catch (error) {
      throw error;
    }
  },
  addExistingScheduleAndAllocate: async (data: any) => {
    try {
      const response = await api.post(
        `${BASE_URL}/add-existing-schedule/${data.projectId}`,
        data
      );
      if (response.data?.isSuccess) {
        return response.data.message;
      } else {
        throw new Error(response.data?.message);
      }
    } catch (error) {
      throw error;
    }
  },
  get: async (projectId: string) => {
    try {
      const response = await api.get(`${BASE_URL}/get-by-project/${projectId}`);
      return response.data.data;
    } catch (error) {
      throw error;
    }
  },
};
